import React from "react";

export type ShowHideProps = {
  show?: boolean;  // permet de rendre le contenu visible
  hide?: boolean;  // permet de cacher le contenu
  children: React.ReactNode;
  hiddenPlaceholder?: React.ReactNode; // Le contenu caché, sera vide "" par défaut
};

export const ShowHide: React.FC<ShowHideProps> = ({
  show = false,  // Par défaut, caché
  hide = false,  // Si hide est true, on cache également
  children,
  hiddenPlaceholder = ""
}) => {
  if (show) {
    return (
      <>
        {children}
      </>
    );
  } else if (hide) {
    return (
      <>
        {hiddenPlaceholder}
      </>
    );
  }

  return <>{hiddenPlaceholder}</>;  // Par défaut, on cache
};
